import axios from 'axios'
import { OK } from 'http-status-codes'
import { useState } from 'react'
import {
  EditController,
  EditView,
  Identifier,
  SaveButton,
  Toolbar,
  useNotify,
  useRedirect,
} from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
import { BaseActionDetailButton } from '../Common/ActionButtons'
import { FuelForm } from './FuelForm'

function updateFuelReceipt(id: Identifier, receipt_payload: any) {
  const url = `/api/v1/console/fuel-receipts/${id}/`
  const formData = new FormData()
  for (const [key, value] of Object.entries<any>(receipt_payload)) {
    formData.append(key, value)
  }
  return axios
    .patch(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      if (response.status === OK) {
        return response.data
      }
    })
}

export function clearFuelReceipt(id: Identifier) {
  const url = `/api/v1/console/fuel-receipts/${id}/`
  return axios.delete(url).then((response) => {
    if (response.status === OK) {
      return response.data
    }
  })
}

const ClearFuelReceipt = (props: any) => {
  const { basePath, isLoading, setIsLoading } = props
  const redirectTo = useRedirect()
  if (!props.record) {
    return null
  }
  return (
    <BaseActionDetailButton
      record={props.record}
      actionRequest={clearFuelReceipt}
      actionTitle="Delete"
      actionText="This fuel receipt will be deleted. Are you sure?"
      basePath={basePath}
      redirectTo={redirectTo}
      button_size={'large'}
      disabled={isLoading}
      handleRequestStart={() => setIsLoading(true)}
      handleRequestEnd={() => setIsLoading(false)}
    />
  )
}

const FuelEditSaveButton = (props: any) => {
  const redirectTo = useRedirect()
  const notify = useNotify()
  const { basePath, isLoading, setIsLoading } = props

  const handleClick = (values: any, redirect: any) => {
    setIsLoading(true)
    const receipt_payload = {
      date_purchased: values.date_purchased,
      fuel_attachment: values.fuel_attachment.rawFile,
      jurisdiction: values.jurisdiction,
      price_per_gallon: values.price_per_gallon,
      reported_by: values.user.id,
      total_gallons: values.total_gallons,
      truck: values.truck.id,
    }
    updateFuelReceipt(values.id, receipt_payload)
      .then(() => {
        notify('Receipt uploaded successfully.', { type: 'success' })
        redirectTo(redirect, basePath)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        if ('date_last_possible_edit' in error.response.data) {
          notify(error.response.data.date_last_possible_edit[0], { type: 'error' })
        } else if ('jurisdiction' in error.response.data) {
          notify(error.response.data.jurisdiction[0], { type: 'error' })
        } else {
          notify(JSON.stringify(error.response.data), { type: 'error' })
          console.error(error.response.data[0])
        }
        captureExceptionIfProduction(error)
      })
  }

  return <SaveButton {...props} onSave={handleClick} disabled={isLoading} />
}

const FuelEditToolbar = (props: any) => (
  <Toolbar {...props}>
    <FuelEditSaveButton style={{ marginRight: 16 }} {...props} />
    <ClearFuelReceipt {...props} />
  </Toolbar>
)

const FuelEdit = (props: any) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <EditController undoable={false} {...props}>
      {(controllerProps) => {
        return (
          <EditView title={'Fuel Tax Edit Receipt'} {...props} {...controllerProps}>
            <FuelForm
              fueltoolbar={<FuelEditToolbar isLoading={isLoading} setIsLoading={setIsLoading} />}
              {...props}
            />
          </EditView>
        )
      }}
    </EditController>
  )
}

export default FuelEdit
